
import { isValidPhoneNumber } from 'react-phone-number-input'

export const comparePasswords = (password, confirmPassword) => {
    if(!confirmPassword) return false
    if(password === confirmPassword) return true
}

export const validateEmail = (email) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email);
export const validatePassword = (password) => {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;
    return passwordRegex.test(password);
}

export const validatePhoneNumber = (number, required) => {
    if (required && !number) {
        return false // If the number is required and empty, return false
    }

    if (!required && !number) {
        return true // If the number is not required and empty, return true
    }

    return isValidPhoneNumber(number) // Check if the number is valid
}

